import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import { getPrivacyPolicy } from "Features/ECOMM/PrivacyPolicy/utils/requests";
import dynamic from "next/dynamic";
import { handleRateLimit } from "utils/handleRateLimit";

const PrivacyPolicy = dynamic(() => import('Features/ECOMM/PrivacyPolicy/components/PrivacyPolicy'));

const Page = ({ data }) => {
    return (
        <PageContextWrapper
            page='privacypolicy'
            page_content={data.template_page_content}
        >
            <PrivacyPolicy {...data}/>
        </PageContextWrapper>
    );
};

export async function getServerSideProps({ query, res }) {
    
    res.setHeader(
        'Cache-Control',
        'public, s-maxage=43200, stale-while-revalidate=59'
      );


    const data = await getPrivacyPolicy();

    const rateLimitRedirect = handleRateLimit(res, data);
    if (rateLimitRedirect) return rateLimitRedirect;

    if(data.exception) {
        return {notFound: true}
    }

    return {
        props: {
            data,
        },
    };
}

export default Page;
